import { cn } from '@repo/ui/utils'

export function InlineCode({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <code
      className={cn(
        'bg-primary-50/80 text-primary relative rounded px-[0.3rem] py-[0.2rem] text-sm font-medium leading-6',
        className,
      )}
    >
      {children}
    </code>
  )
}
